
import { Metadata } from 'next'
import Link from 'next/link'
import CopyButton from '@/utils/shareOptions/CopyButton'
import urls from '@/utils/urls/urls'

let MetaDynamicData = {
    title: "Blog Details | TEX EXCELLENCE LIMITED",
    description: "Blog Details | TEX EXCELLENCE LIMITED",
}


const BlogDetails = ({ blog }: { blog: any }) => {

    return (
        <div className="bg-white">
            <main className="main">
                {/* breadcrumb */}
                <div
                    className="site-breadcrumb"
                    style={{ background: "url(../../assets/img/breadcrumb/01.jpg)" }}
                >
                    <div className="container">
                        <h2 className="breadcrumb-title">{blog?.title}</h2>
                        <ul className="breadcrumb-menu">
                            <li>
                                <Link href="/">Home</Link>
                            </li>
                            <li className="active">Blog Details</li>
                        </ul>
                    </div>
                </div>
                {/* breadcrumb end */}
                {/* blog single */}
                <div className="blog-single py-120">
                    <div className="container">
                        <div className="row g-4">
                            <div className="col-lg-12">
                                <div className="blog-single-wrap">
                                    <div className="blog-single-content">
                                        <div className="blog-thumb-img">
                                            <img src={urls?.image + blog?.blog_img} alt="thumb" />
                                        </div>
                                        <div className="blog-info">
                                            <div className="blog-meta">
                                                <div className="blog-meta-left">
                                                    <ul>
                                                        {
                                                            blog?.blog_category?.map((tag: any) => (
                                                                <li key={tag.id}>
                                                                    {/* <i className="far fa-user" /> */}
                                                                    <i className="fas fa-tags" />
                                                                    <Link href={`/blogs/${blog?.id}`}>
                                                                        {tag?.title}
                                                                    </Link>
                                                                </li>
                                                            ))
                                                        }
                                                        {/* <li>
                                                                <i className="far fa-user" />
                                                                <a href="#">Jean R Gunter</a>
                                                            </li> */}
                                                        {/* <li>
                                                            <i className="far fa-comments" />
                                                            3.2k Comments
                                                        </li>
                                                        <li>
                                                            <i className="far fa-thumbs-up" />
                                                            1.4k Like
                                                        </li> */}
                                                    </ul>
                                                </div>
                                                <div className="blog-meta-right">
                                                    <div className="share-link">
                                                        <i className="far fa-share-alt" />
                                                        <CopyButton>
                                                            Share
                                                        </CopyButton>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="blog-details">
                                                <h3 className="blog-details-title mb-20">
                                                    {blog?.title}
                                                </h3>
                                                <div className="mb-10">
                                                    {blog?.long_description && <div dangerouslySetInnerHTML={{ __html: blog?.long_description }} />}
                                                    {/* {blog?.long_description} */}
                                                    {/* odit aut fugit, sed quia consequuntur magni dolores eos
                                                    qui ratione voluptatem sequi nesciunt. Neque porro
                                                    quisquam est, qui dolorem ipsum quia dolor sit amet,
                                                    consectetur, adipisci velit, sed quia non numquam eius
                                                    modi tempora incidunt ut labore et dolore magnam aliquam
                                                    quaerat voluptatem. */}
                                                </div>
                                                {/* <p className="mb-10">
                                                    But I must explain to you how all this mistaken idea of
                                                    denouncing pleasure and praising pain was born and I will
                                                    give you a complete account of the system, and expound the
                                                    actual teachings of the great explorer of the truth, the
                                                    master-builder of human happiness. No one rejects,
                                                    dislikes, or avoids pleasure itself, because it is
                                                    pleasure, but because those who do not know how to pursue
                                                    pleasure rationally encounter consequences that are
                                                    extremely painful.
                                                </p> */}
                                                {/* <blockquote className="blockqoute">
                                                    It is a long established fact that a reader will be
                                                    distracted by the readable content of a page when looking
                                                    at its layout. The point of using orem psum is that it has
                                                    a more-or-less the majority have suffered alteration
                                                    normal distribution.
                                                    <h6 className="blockqoute-author">Mark Crawford</h6>
                                                    <i className="fal fa-quote-right blockqoute-icon" />
                                                </blockquote>
                                                <p className="mb-20">
                                                    In a free hour when our power of choice is untrammelled
                                                    and when nothing prevents our being able to do what we
                                                    like best, every pleasure is to be welcomed and every pain
                                                    avoided. But in certain circumstances and owing to the
                                                    claims of duty or the obligations of business it will
                                                    frequently occur that pleasures have to be repudiated and
                                                    annoyances accepted. The wise man therefore always holds
                                                    in these matters to this principle of selection.
                                                </p> */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-20">
                                                        <img src="assets/img/blog/01.jpg" alt="" />
                                                    </div>
                                                    <div className="col-md-6 mb-20">
                                                        <img src="assets/img/blog/02.jpg" alt="" />
                                                    </div>
                                                </div>
                                                {/* <p className="mb-20">
                                                    Power of choice is untrammelled and when nothing prevents
                                                    our being able to do what we like best, every pleasure is
                                                    to be welcomed and every pain avoided. But in certain
                                                    circumstances and owing to the claims of duty or the
                                                    obligations of business it will frequently occur that
                                                    pleasures have to be repudiated and annoyances accepted.
                                                    The wise man therefore always holds in these matters to
                                                    this principle of selection.
                                                </p> */}
                                                <hr />
                                                <div className="blog-details-tag pb-20">
                                                    <h5>Tags : </h5>
                                                    <ul>
                                                        {
                                                            blog?.blog_category?.map((tag: any) => (
                                                                <li key={tag?.id}>
                                                                    <a href="#">{tag?.title}</a>
                                                                </li>
                                                            ))
                                                        }
                                                        {/* <li>
                                                            <a href="#">Solar</a>
                                                        </li>
                                                        <li>    
                                                            <a href="#">Energy</a>
                                                        </li>
                                                        <li>
                                                            <a href="#">Battery</a>
                                                        </li> */}
                                                    </ul>
                                                </div>
                                            </div>
                                            {/* <div className="blog-author">
                                                <div className="blog-author-img">
                                                    <img src="assets/img/blog/author.jpg" alt="" />
                                                </div>
                                                <div className="author-info">
                                                    <h6>Author</h6>
                                                    <h3 className="author-name">Shelly Frederick</h3>
                                                    <p>
                                                        It is a long established fact that a reader will be
                                                        distracted by the abcd readable content of a page when
                                                        looking at its layout that more less.
                                                    </p>
                                                    <div className="author-social">
                                                        <a href="#">
                                                            <i className="fab fa-facebook-f" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fab fa-x-twitter" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fab fa-instagram" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fab fa-whatsapp" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fab fa-youtube" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                        {/* <div className="blog-comment">
                                            <h3>Comments (20)</h3>
                                            <div className="blog-comment-wrap">
                                                <div className="blog-comment-item">
                                                    <img src="assets/img/blog/com-1.jpg" alt="thumb" />
                                                    <div className="blog-comment-content">
                                                        <h5>Rosa Fossum</h5>
                                                        <span>
                                                            <i className="far fa-clock" /> Aug 23, 2024
                                                        </span>
                                                        <p>
                                                            There are many variations of passages the majority
                                                            have suffered in some injected humour or randomised
                                                            words which don't look even slightly believable.
                                                        </p>
                                                        <a href="#">
                                                            <i className="far fa-reply" /> Reply
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="blog-comment-item reply">
                                                    <img src="assets/img/blog/com-2.jpg" alt="thumb" />
                                                    <div className="blog-comment-content">
                                                        <h5>Timothy Stone</h5>
                                                        <span>
                                                            <i className="far fa-clock" /> Aug 23, 2024
                                                        </span>
                                                        <p>
                                                            There are many variations of passages the majority
                                                            have suffered in some injected humour or randomised
                                                            words which don't look even slightly believable.
                                                        </p>
                                                        <a href="#">
                                                            <i className="far fa-reply" /> Reply
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="blog-comment-item">
                                                    <img src="assets/img/blog/com-3.jpg" alt="thumb" />
                                                    <div className="blog-comment-content">
                                                        <h5>Stacey Anthony</h5>
                                                        <span>
                                                            <i className="far fa-clock" /> Aug 23, 2024
                                                        </span>
                                                        <p>
                                                            There are many variations of passages the majority
                                                            have suffered in some injected humour or randomised
                                                            words which don't look even slightly believable.
                                                        </p>
                                                        <a href="#">
                                                            <i className="far fa-reply" /> Reply
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="blog-comment-form">
                                                <h3>Leave A Comment</h3>
                                                <form action="#">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <div className="form-icon">
                                                                    <i className="far fa-user-tie" />
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="name"
                                                                        placeholder="Your Name*"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <div className="form-icon">
                                                                    <i className="far fa-envelope" />
                                                                    <input
                                                                        type="email"
                                                                        className="form-control"
                                                                        name="email"
                                                                        placeholder="Your Email*"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <div className="form-icon">
                                                                    <i className="far fa-pen" />
                                                                    <textarea
                                                                        name="message"
                                                                        cols={30}
                                                                        rows={5}
                                                                        className="form-control"
                                                                        placeholder="Your Comment*"
                                                                        required
                                                                        defaultValue={""}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <button type="submit" className="theme-btn">
                                                                Post Comment <i className="far fa-paper-plane" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            {/* aside blog */}
                            {/* <BlogAside /> */}

                        </div>
                    </div>
                </div>
                {/* blog single end */}
            </main>
            {/* footer area */}

            {/* scroll-top */}
            <a href="#" id="scroll-top">
                <i className="far fa-arrow-up" />
            </a>
            {/* scroll-top end */}
            {/* js */}
        </div>
    )
}

export const metadata: Metadata = {
    title: MetaDynamicData.title,
    description: MetaDynamicData.description,
}


const BlogAside = () => {
    return (
        <div className="col-lg-4">
            <aside className="blog-sidebar">
                {/* search*/}
                <div className="widget search">
                    <h5 className="widget-title">Search</h5>
                    <div className="search-form">
                        <form action="#">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Here..."
                                />
                                <button type="submit">
                                    <i className="far fa-search" />
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                {/* category */}
                <div className="widget category">
                    <h5 className="widget-title">Category</h5>
                    <div className="category-list">
                        <a href="#">
                            <i className="far fa-arrow-right" />
                            Solar Panels<span>(10)</span>
                        </a>
                        <a href="#">
                            <i className="far fa-arrow-right" />
                            Wind Generators<span>(15)</span>
                        </a>
                        <a href="#">
                            <i className="far fa-arrow-right" />
                            Easy Installation<span>(20)</span>
                        </a>
                        <a href="#">
                            <i className="far fa-arrow-right" />
                            Solar Maintenance<span>(30)</span>
                        </a>
                        <a href="#">
                            <i className="far fa-arrow-right" />
                            Hydraulic Power<span>(25)</span>
                        </a>
                    </div>
                </div>
                {/* recent post */}
                <div className="widget recent-post">
                    <h5 className="widget-title">Recent Post</h5>
                    <div className="recent-post-item">
                        <div className="recent-post-img">
                            <img src="assets/img/blog/bs-1.jpg" alt="thumb" />
                        </div>
                        <div className="recent-post-info">
                            <h6>
                                <a href="#">
                                    There are many variatio of passage majority.
                                </a>
                            </h6>
                            <span>
                                <i className="far fa-clock" />
                                Aug 23, 2024
                            </span>
                        </div>
                    </div>
                    <div className="recent-post-item">
                        <div className="recent-post-img">
                            <img src="assets/img/blog/bs-2.jpg" alt="thumb" />
                        </div>
                        <div className="recent-post-info">
                            <h6>
                                <a href="#">
                                    There are many variatio of passage majority.
                                </a>
                            </h6>
                            <span>
                                <i className="far fa-clock" />
                                Aug 23, 2024
                            </span>
                        </div>
                    </div>
                    <div className="recent-post-item">
                        <div className="recent-post-img">
                            <img src="assets/img/blog/bs-3.jpg" alt="thumb" />
                        </div>
                        <div className="recent-post-info">
                            <h6>
                                <a href="#">
                                    There are many variatio of passage majority.
                                </a>
                            </h6>
                            <span>
                                <i className="far fa-clock" />
                                Aug 23, 2024
                            </span>
                        </div>
                    </div>
                </div>
                {/* social share */}
                <div className="widget social">
                    <h5 className="widget-title">Follow Us</h5>
                    <div className="social-link">
                        <a href="#">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="#">
                            <i className="fab fa-x-twitter" />
                        </a>
                        <a href="#">
                            <i className="fab fa-dribbble" />
                        </a>
                        <a href="#">
                            <i className="fab fa-whatsapp" />
                        </a>
                        <a href="#">
                            <i className="fab fa-youtube" />
                        </a>
                    </div>
                </div>
                {/* Recent Post */}
                <div className="widget tag">
                    <h5 className="widget-title">Popular Tags</h5>
                    <div className="tag-list">
                        <a href="#">Solar</a>
                        <a href="#">Energy</a>
                        <a href="#">System</a>
                        <a href="#">Hydro</a>
                        <a href="#">Battery</a>
                        <a href="#">Wind</a>
                        <a href="#">Installation</a>
                        <a href="#">Power</a>
                    </div>
                </div>
            </aside>
        </div>
    )
}


export default BlogDetails
